<template>
  <div class='title-div'>
    <wc-page-title title='Week View' :subtitle='subtitle' fullWidth></wc-page-title>
    <shift-buttons
      title='This Week'
      dayButton
      monthButton
      :disableToday='disableToday'
      :date='date'
      :showWOs='showWOs'
      :loading='isLoading'
      @clearScheduleData='clearScheduleData'
      @prev='goToPrevWeek'
      @today='goToThisWeek'
      @next='goToNextWeek'
      @deselect="deselect"
      @toggleShowWOs='showWOs = !showWOs'
      @archiveWOs="$emit('archiveWOs')"
    ></shift-buttons>

      <!-- <div class='scroll-container'> -->
        <!-- <div> -->
          <div :class='[$store.state.nav.showDrawer ? "schedule-container" : "schedule-container-expanded-weekview", {"overflow": !$vuetify.breakpoint.xl}]'>
            <table class='sch-items-table'>
              <tr>
                <td v-for='(day, index) in days' :key='index' valign='top' :class='[getDayClass(index), {"sticky": $vuetify.breakpoint.xl && !$store.state.nav.showDrawer}]'>
                  <day-header :date='day.date' @clearScheduleData='clearScheduleData'></day-header>
                </td>
              </tr>
              <tr>
                <td v-for='(day, index) in days' :key='index' valign='top' :class='getDayClass(index)'>


                  <div class='mt-2'>
                    <table width='100%'>
                      <tr>
                        <td height='100%' class='schedule-items-box'>
                          <!-- <wc-loading v-if='isLoading' line msg='Loading items...'></wc-loading> -->
                            <route
                              v-for='route in day.routes'
                              :key='route.id'
                              :isLoading='isLoading'
                              :route='route'
                              :showWOs='showWOs'
                              :showInsertBox='showInsertBox'
                              @getFullRoute='getFullRoute'
                              @select='select'
                              @deselect='deselect'
                              @openCrewVisits='openCrewVisits'
                              @deleteRoute='deleteRoute'
                              @openQuickView='openQuickView'
                              @updateRoute='updateRoute'
                              @moveWOs='moveWOs'
                              @updateWO='updateWO'
                            ></route>
                          <add-route-button
                            :date='getDate(index)'
                            :schedule='schedule'
                            @addRoute='addRoute'
                          ></add-route-button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <v-divider class='ml-4' width='1585px'></v-divider>
          <!-- this divider isn't optimal, but it doesn't work in any other spot unless layout is rebuilt -->
        <!-- </div> -->
      <!-- </div> -->
  </div>
</template>

<script>
import moment from 'moment'
import Route from './Route'
import ShiftButtons from '../../components/ShiftButtons'
import DayHeader from '@/modules/schedule/components/scheduleDetail/DayHeader'
import AddRouteButton from './AddRouteButton'

export default {
  name: 'week-view',
  props: {
    routes: {
      required: true
    },
    isLoading: {
      required: true
    },
    schedule: {
      required: true
    }
  },
  data: () => ({
    showWOs: false,
    headerClass: 'overline font-weight-bold',
  }),
  computed: {
    showInsertBox () {
      return this.$store.state.schedule.selectedWOs.length > 0
    },
    subtitle () {
      return this.$options.filters.shortDate(this.weekStart) + ' – ' + this.$options.filters.shortDate(this.weekEnd)
    },
    date () {
      return moment(this.$route.params.date).format('YYYY-MM-DD').toString()
    },
    today () {
      return moment().format('YYYY-MM-DD').toString()
    },
    nextWeek () {
      return moment(this.$route.params.date).add(1, 'weeks').format('YYYY-MM-DD').toString()
    },
    prevWeek () {
      return moment(this.$route.params.date).subtract(1, 'weeks').format('YYYY-MM-DD').toString()
    },
    weekStart () {
      // the date the week should start on
      return moment(this.$route.params.date).weekday(0).format('YYYY-MM-DD').toString()
    },
    weekEnd () {
      // the date the week should end on
      return moment(this.$route.params.date).weekday(6).format('YYYY-MM-DD').toString()
    },
    nextWeekStart () {
      return moment(this.$route.params.date).add(1, 'weeks').weekday(0).format('YYYY-MM-DD').toString()
    },
    nextWeekEnd () {
      return moment(this.$route.params.date).add(1, 'weeks').weekday(6).format('YYYY-MM-DD').toString()
    },
    prevWeekStart () {
      return moment(this.$route.params.date).subtract(1, 'weeks').weekday(0).format('YYYY-MM-DD').toString()
    },
    prevWeekEnd () {
      return moment(this.$route.params.date).subtract(1, 'weeks').weekday(6).format('YYYY-MM-DD').toString()
    },
    disableToday () {  // disables 'return to this week' button if already on current week.
      return moment(this.$route.params.date).isSame(this.today, 'week')
    },
    days () {
      let daysArray = []
      for (let d = 0; d < 7; d++) {
        let day = {}
        day.date = this.getDate(d)
        day.routes = this.routes.filter(s => s.date === day.date)
        daysArray.push(day)
      }
      return daysArray
    }
  },
  mounted () {
    console.log('week view mounted')
    this.$emit('dateChange', this.weekStart, this.weekEnd)
  },
  methods: {
    goToThisWeek () {
      this.$router.push({ name: 'ScheduleWeek', params: { id: this.$route.params.id, date: this.today } })
      this.$emit('dateChange', this.weekStart, this.weekEnd)
      // in this case emit after is the function only to receive new params value for this.today which the function calls
      // (otherwise weekEnd and weekStart are calculating from the old params and not the new date they need)
    },
    goToNextWeek () {
      this.$emit('dateChange', this.nextWeekStart, this.nextWeekEnd)
      this.$router.push({ name: 'ScheduleWeek', params: { id: this.$route.params.id, date: this.nextWeek } })
    },
    goToPrevWeek () {
      this.$emit('dateChange', this.prevWeekStart, this.prevWeekEnd)
      this.$router.push({ name: 'ScheduleWeek', params: { id: this.$route.params.id, date: this.prevWeek } })
    },
    getDate (dayNumber) {
      return moment(this.weekStart).add(dayNumber, 'days').format('YYYY-MM-DD').toString()
    },
    getDayClass (i) {
      // gets the i from the for loop
      let ret = []
      ret.push('dayClass')
      if (i > 0) {
        if (i % 2 === 0) {
            ret.push('oddDayBorder')
          } else {
            ret.push('evenDayBorder')
          }
      } else {
        ret.push('startDay')
      }
      return ret
    },
    addRoute (route) {
      this.$emit('addRoute', route)
    },
    updateRoute (route) {
      this.$emit('updateRoute', route)
    },
    openQuickView (wo) {
      this.$emit('openQuickView', wo)
    },
    deleteRoute (route) {
      this.$emit('deleteRoute', route)
    },
    openCrewVisits (wo) {
      this.$emit('openCrewVisits', wo)
    },
    updateWO (wo) {
      this.$emit('updateWO', wo)
    },
    select (woArray) {
      this.$emit('select', woArray)
    },
    deselect (woArray) {
      this.$emit('deselect', woArray)
    },
    getFullRoute (routeID) {
      this.$emit('getFullRoute', routeID)
    },
    moveWOs (routeID, beforeWoID = 0) {
      this.$emit('moveWOs', routeID, beforeWoID)
    },
    clearScheduleData () {
      this.$emit('clearScheduleData')
    },
  },
  components: {
    'add-route-button': AddRouteButton,
    'shift-buttons': ShiftButtons,
    'route': Route,
    'day-header': DayHeader
  }
}
</script>

<style>
.sch-items-table {
  border-collapse: collapse;
}

.dayClass {
  height: 100%;
  width: 220px !important;
}

.startDay {
  background-color: #FFF !important;
  border-left: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.oddDay {
  background-color: #FFF !important;
}

.evenDay {
  background-color: #FAFAFA !important;
}

.evenDayBorder {
  background-color: #FAFAFA !important;
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.oddDayBorder {
  background-color: #FFF !important;
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 3.5rem;
  z-index: 2;
}

.overflow {
  overflow-x: auto;
}
</style>
